// 彭亨州球场数据
// Pahang Golf Courses

export const PAHANG_COURSES = {
  "AWANA_GENTING_HIGHLANDS_Golf_AND_COUNTRY_RESORT": {
    shortName: "AGHGCR",
    fullName: "Awana Genting Highlands Golf & Country Resort",
    location: ["Genting Highlands", "Pahang", "Malaysia"],
    pars: [4,4,4,3,5,3,4,5,3, 4,4,5,5,4,3,4,3,4],
    index: [1,17,7,15,5,13,9,3,11, 4,14,12,6,16,10,2,18,8]
  },

  "BENTONG_GOLF_CLUB": {
    shortName: "BGC",
    fullName: "Bentong Golf Club",
    location: ["Bentong", "Pahang", "Malaysia"],
    pars: [4,4,4,3,4,3,5,4,5, 3,4,4,4,5,3,4,4,5],
    index: [13,15,5,7,1,17,9,11,3, 12,16,14,8,6,18,2,4,10]
  },

  "BERJAYA_HILLS_GOLF_AND_COUNTRY_CLUB": {
    shortName: "BHGCC",
    fullName: "Berjaya Hills Golf & Country Club",
    location: ["Bukit Tinggi", "Pahang", "Malaysia"],
    pars: [4,5,3,4,4,3,4,5,4, 5,3,4,4,4,4,3,4,5],
    index: [11,3,17,1,5,13,15,7,9, 8,10,12,6,16,2,18,4,14]
  },

  "BUKIT_TINGGI_GOLF_AND_COUNTRY_CLUB": {
    shortName: "BTGCC",
    fullName: "Bukit Tinggi Golf & Country Club",
    location: ["Bukit Tinggi", "Pahang", "Malaysia"],
    pars: [4,5,3,4,4,3,4,5,4, 5,3,4,4,4,4,3,4,5],
    index: [11,3,17,1,5,13,15,7,9, 8,10,12,6,16,2,18,4,14]
  },

  "FRASER_HILL_GOLF_ AND_COUNTRY_CLUB": {
    shortName: "FHGCC",
    fullName: "FRASER'S HILL GOLF & COUNTRY CLUB",
    location: ["Fraser's Hill", "Pahang", "Malaysia"],
    pars: [4,4,4,3,4,4,5,3,4, 4,5,3,5,4,3,3,4,4],
    index: [11,7,2,15,17,14,4,10,6, 16,3,18,1,5,8,12,13,9]
  },

  "KELAB_GOLF_DIRAJA_PEKAN": {
    shortName: "KGDP",
    fullName: "Kelab Golf Diraja Pekan",
    location: ["Pekan", "Pahang", "Malaysia"],
    pars: [4,5,4,4,3,5,3,4,4, 4,3,4,5,4,3,5,4,4],
    index: [15,5,9,1,13,7,17,3,11, 10,14,12,4,2,18,6,16,8]
  },

  "KELAB_GOLF_SULTAN_AHMAD_SHAH_CAMERON": {
    shortName: "KGSAS-CH",
    fullName: "Kelab Golf Sultan Ahmad Shah Cameron Highlands",
    location: ["Cameron Highlands", "Pahang", "Malaysia"],
    pars: [5,4,4,3,4,4,5,3,4, 4,4,3,5,4,3,4,3,5],
    index: [9,7,3,17,13,1,5,11,15, 4,6,14,2,10,18,12,16,8]
  },

  "KELAB_REKREASI_SRI_MAHKOTA": {
    shortName: "KRSM",
    fullName: "Kelab Rekreasi Sri Mahkota",
    location: ["Temerloh", "Pahang", "Malaysia"],
    pars: [4,4,4,3,5,3,4,5,4, 5,4,4,3,5,3,4,4,4],
    index: [1,13,9,17,3,15,5,7,11, 8,14,10,18,4,16,6,2,12]
  },

  "KELAB_REKREASI_TUDM_KUANTAN": {
    shortName: "KRTK",
    fullName: "Kelab Rekreasi TUDM Kuantan",
    location: ["Kuantan", "Pahang", "Malaysia"],
    pars: [4,4,3,4,5,4,3,5,4],
    index: [4,3,5,6,1,7,9,2,8]
  },

  "Indera_Kuantan_Golf_Club": {
    shortName: "IKGC",
    fullName: "Indera Kuantan Golf Club",
    location: ["Kuantan", "Pahang", "Malaysia"],
    pars: [4,5,3,5,4,3,4,4,4],
    index: [8,4,7,1,2,9,3,5,6]
  },

  "MAHKOTA_GOLF_AND_COUNTRY_CLUB": {
    shortName: "MGCC",
    fullName: "Mahkota Golf & Country Club",
    location: ["Kuantan", "Pahang", "Malaysia"],
    pars: [4,3,4,4,5,4,4,3,5, 4,3,5,4,4,5,4,3,4],
    index: [17,3,15,13,11,1,7,5,9, 4,18,14,8,16,10,12,2,6]
  },

  "MARAN_HILL_GOLF_RESORT": {
    shortName: "MHGR",
    fullName: "Maran Hill Golf Resort",
    location: ["Maran", "Pahang", "Malaysia"],
    pars: [4,5,3,5,4,4,3,4,4, 5,4,4,3,4,4,5,3,4],
    index: [1,13,15,11,3,7,17,5,9, 10,2,18,16,14,4,8,6,12]
  },

  "ROYAL_PAHANG_GOLF_CLUB": {
    shortName: "RPGC",
    fullName: "Royal Pahang Golf Club",
    location: ["Kuantan", "Pahang", "Malaysia"],
    pars: [5,4,4,4,3,5,4,3,4, 5,3,4,4,4,4,3,4,5],
    index: [11,7,1,9,15,5,13,17,3, 14,16,6,4,8,2,18,10,12]
  },

  "ROYAL_PEKAN_GOLF_CLUB": {
    shortName: "RPGC",
    fullName: "Royal Pekan Golf Club",
    location: ["Pekan", "Pahang", "Malaysia"],
    pars: [4,5,4,4,3,5,3,4,4, 4,3,4,5,4,3,5,4,4],
    index: [15,5,9,1,13,7,17,3,11, 10,14,12,4,2,18,6,16,8]
  },

  "SELESA_HILLHOMES_AND_GOLF_RESORT": {
    shortName: "SHGR",
    fullName: "Selesa Hillhomes & golf resort",
    location: ["Bentong", "Pahang", "Malaysia"],
    pars: [5,4,4,3,4,3,4,4,5, 4,3,5,3,4,5,5,3,4],
    index: [3,9,13,15,7,17,11,5,1, 12,14,6,16,10,2,4,18,8]
  },

  "TIOMAN_ISLAND_GOLF_CLUB": {
    shortName: "TIGC",
    fullName: "Tioman Island Golf Club",
    location: ["Pulau Tioman", "Pahang", "Malaysia"],
    pars: [4,3,5,4,4,4,3,4,5, 4,3,5,4,4,4,3,4,4],
    index: [13,15,5,17,3,9,7,11,1, 6,12,8,4,14,16,18,10,2]
  },

  "VILLEA_ROMPIN_RESORT_&_GOLF": {
    shortName: "VRRG",
    fullName: "Villea Rompin Resort & Golf",
    location: ["Rompin", "Pahang", "Malaysia"],
    pars: [4,4,4,4,3,5,3,5,4, 4,5,3,4,4,4,4,3,5],
    index: [17,7,1,3,13,15,11,9,5, 18,4,14,10,2,16,8,12,6]
  }
};

export default PAHANG_COURSES;
